(function () {
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  // ---- Product gallery: quiet Swiper's screen-reader chatter ----
  ready(function () {
    var gallery = document.querySelector('media-gallery.media-gallery--carousel');
    if (!gallery) return;
    function quiet() {
      gallery.querySelectorAll('slideshow-component').forEach(function (el) {
        var s = el.swiper;
        if (s && s.params && s.params.a11y) s.params.a11y.enabled = false;
        var isThumb = el.classList.contains('swiper-thumbs');
        el.querySelectorAll('.swiper-slide').forEach(function (sl) {
          sl.removeAttribute('aria-label'); sl.removeAttribute('role');
          if (isThumb) sl.setAttribute('aria-hidden','true');
          else if (sl.classList.contains('swiper-slide-active')) sl.removeAttribute('aria-hidden');
          else sl.setAttribute('aria-hidden','true');
        });
        if (isThumb) {
          el.setAttribute('aria-hidden','true');
          el.querySelectorAll('a, button, [tabindex]').forEach(function (n){ n.setAttribute('tabindex','-1'); });
        }
        var notif = el.querySelector('.swiper-notification');
        if (notif) notif.setAttribute('aria-live','off');
      });
    }
    quiet(); setTimeout(quiet, 500); setTimeout(quiet, 1500);
    var deb;
    new MutationObserver(function(){ clearTimeout(deb); deb = setTimeout(quiet, 120); })
      .observe(gallery, { subtree:true, childList:true, attributes:true, attributeFilter:['class'] });
  });

  // ---- Mini-cart: focus-managed dialog (announces once, after content settles) ----
  ready(function () {
    var SEL = '.cart-drawer__dialog';
    var lastFocused = null, trapping = false, opened = false, settle = null;
    function drawer(){ return document.querySelector(SEL); }
    function isVisible(el){ if(!el) return false; var c=getComputedStyle(el), r=el.getBoundingClientRect(); return c.visibility!=='hidden' && c.display!=='none' && parseFloat(c.opacity)>0.01 && r.width>1 && r.height>1; }
    function focusables(d){ return Array.prototype.slice.call(d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')).filter(isVisible); }
    function onKeydown(e){
      if(!trapping) return;
      var d=drawer(); if(!d) return;
      if(e.key==='Escape'||e.keyCode===27){ var c=d.querySelector('.cart-drawer__close-button'); if(c) c.click(); return; }
      if(e.key!=='Tab'&&e.keyCode!==9) return;
      var f=focusables(d); if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(!d.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
      else if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    }
    var renderObs = new MutationObserver(function(){ if(opened && !trapping) schedule(); });
    function schedule(){
      if(trapping || !opened) return;
      clearTimeout(settle);
      settle = setTimeout(focusOnce, 350);
    }
    function focusOnce(){
      if(trapping || !opened) return;
      var d=drawer();
      if(!d || !isVisible(d)){ schedule(); return; }
      d.setAttribute('role','dialog'); d.setAttribute('aria-modal','true'); d.removeAttribute('aria-hidden');
      var h = d.querySelector('.minicart-title');
      if(h){ if(!h.id) h.id='minicart-a11y-title'; d.setAttribute('aria-labelledby', h.id); d.removeAttribute('aria-label'); }
      else { d.setAttribute('aria-label','Shopping cart'); }
      var target = d.querySelector('.cart-drawer__close-button') || h || d;
      if(target===d && !d.hasAttribute('tabindex')) d.setAttribute('tabindex','-1');
      target.focus();
      trapping = true;
      renderObs.disconnect();
    }
    function open(){ opened=true; lastFocused=document.activeElement; renderObs.observe(document.body,{subtree:true,childList:true}); schedule(); }
    function close(){ opened=false; trapping=false; clearTimeout(settle); renderObs.disconnect(); if(lastFocused && typeof lastFocused.focus==='function') lastFocused.focus(); lastFocused=null; }

    document.addEventListener('keydown', onKeydown, true);
    var minicartDrower = document.querySelector('.cart-drawer__dialog');
    new MutationObserver(function(){
      var active = minicartDrower.hasAttribute('open');
      console.log('observer', active);
      if(active && !opened) open();
      else if(!active && opened) close();
    }).observe(minicartDrower,{attributes:true,attributeFilter:['open']});
  });
})();